// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const FooterNavLinksListCss = css`
  list-style-type: none;
  padding-inline-start: 0;
  margin: 0;
  li {
    height: 34px;
    ${(props) =>
      props.insideAcccordion
        ? `
        padding: 18px 28px 0;
        font-size: ${props.theme.fonts.fontSize.body.large.secondary}px;
      `
        : `
        padding: 0 0 6px;
        font-size: ${props.theme.fonts.fontSize.listmenu.large}px;
      `}
  }
  a,
  button,
  .footer-hover {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.body.large.secondary}px;
    line-height: ${(props) => props.theme.fonts.lineHeight.medium};
    letter-spacing: ${(props) => props.theme.fonts.letterSpacing.normal};
    color: ${(props) => props.theme.colors.ACCORDION.TEXT};
    border-radius: 0;
    :hover {
      border-bottom: 2px solid ${(props) => props.theme.colorPalette.primary.main};
      padding-bottom: 4px;
      text-decoration: none;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.fonts.fontSize.promo2.large}px;
    }
  }
  &.list {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }

  .footer-hover {
    width: max-content;
  }
  &.divider {
    border-bottom: 1px solid #d8d8d8;
    width: 90%;
    margin-top: 20px;
    margin-bottom: 20px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      display: none;
    }
  }

  &.flex-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;
    &.list li {
      flex: 1 1 50%; /* Each item takes up 50% of the container width */
      box-sizing: border-box; /* Ensures padding and border are included in the width calculation */
      padding-bottom: 0;
      height: 27px;
    }
    &.list li button,
    &.list li a {
      color: #595959;
      font-family: Nunito;
      font-size: 11px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 16.5px */
      text-decoration-line: underline;
      :hover {
        border-bottom: none;
        padding-bottom: 0;
        text-decoration-line: underline;
      }
    }
    .list {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding-top: 16px;
      padding-bottom: 6px;
      margin-top: 0;

      background-color: #fafafa;

      &.list li {
        padding: 0 14px 0;
      }
      &.list li button,
      &.list li a {
        color: #595959;
        font-family: Nunito;
        font-size: 11px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 16.5px */
        text-decoration-line: underline;
        text-transform: capitalize;
      }
    }
  }
`;

export default FooterNavLinksListCss;
